import { Label } from 'reactstrap';

export default Label;
